import Axios from 'axios';

const API_URL = process.env.API_URL + '/api/v3/data/products/sub-brands';

class SubBrands {
  index(params = {}) {
    return Axios.get(API_URL, { params });
  }

  show(brand) {
    return Axios.get(`${API_URL}/${brand}`);
  }
}

export default new SubBrands();


// WEBPACK FOOTER //
// ./src/api/subBrandsV3.js